import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { partnerApi } from "../lib/partnerAuth";
import { Input } from "../components/ui/input";
import { Search } from "lucide-react";

function fmtDate(d) { if (!d) return "—"; try { return new Date(d).toLocaleDateString(); } catch { return d; } }

const stageBadge = (s) => {
  const map = {
    "Admission Complete": "bg-green-50 text-green-800 border-green-300",
    "Conditional Offer Issued": "bg-blue-50 text-blue-800 border-blue-300",
    "Unconditional Offer Issued": "bg-blue-50 text-blue-800 border-blue-300",
    "Offer Sent to Partner": "bg-blue-50 text-blue-800 border-blue-300",
    "Fees Pending": "bg-amber-50 text-amber-800 border-amber-300",
    "Fees Paid": "bg-emerald-50 text-emerald-800 border-emerald-300",
    "PAL Pending": "bg-amber-50 text-amber-800 border-amber-300",
    "PAL Issued": "bg-teal-50 text-teal-800 border-teal-300",
  };
  return map[s] || "bg-slate-50 text-slate-700 border-slate-300";
};

export default function PartnerDashboard() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const r = await partnerApi.get(`/partner/applications${q ? `?q=${encodeURIComponent(q)}` : ""}`);
    setRows(r.data);
    setLoading(false);
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q]); // eslint-disable-line

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="heading-font text-3xl font-bold text-slate-900">Your students</h1>
          <p className="text-sm text-slate-500 mt-1">{rows.length} application{rows.length !== 1 ? "s" : ""}</p>
        </div>
        <div className="relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <Input data-testid="partner-search" value={q} onChange={e=>setQ(e.target.value)} placeholder="Search student or ID…" className="pl-9 bg-white w-72" />
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="text-left px-4 py-3">App ID</th>
              <th className="text-left px-4 py-3">Student</th>
              <th className="text-left px-4 py-3">College</th>
              <th className="text-left px-4 py-3">Program</th>
              <th className="text-left px-4 py-3">Intake</th>
              <th className="text-left px-4 py-3">Stage</th>
              <th className="text-left px-4 py-3">BDM</th>
              <th className="text-left px-4 py-3">Received</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} className="px-4 py-6 text-center text-slate-400">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={8} className="px-4 py-6 text-center text-slate-500">No applications yet.</td></tr>}
            {rows.map(a => (
              <tr key={a.id} data-testid={`partner-app-row-${a.application_id}`} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 mono text-xs"><Link to={`/partner/applications/${a.id}`} className="text-orange-600 hover:underline">{a.application_id}</Link></td>
                <td className="px-4 py-3 font-medium">{a.student_name}</td>
                <td className="px-4 py-3">{a.college}</td>
                <td className="px-4 py-3">{a.program}</td>
                <td className="px-4 py-3">{a.intake}</td>
                <td className="px-4 py-3"><span className={`stage-badge ${stageBadge(a.stage)}`}>{a.stage}</span></td>
                <td className="px-4 py-3 text-slate-600">{a.bdm_name || "—"}</td>
                <td className="px-4 py-3 text-xs text-slate-500">{fmtDate(a.date_received)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
